// extracted by mini-css-extract-plugin
export default {"Banner":"Discount_Banner__nldeg","Media":"Discount_Media__yToGY","BannerGrid":"Discount_BannerGrid__stRUp","DiscountContainer":"Discount_DiscountContainer__pKfxL"};